
import { useSocialMetricsRealtime } from './useSocialMetricsRealtime';

/**
 * A hook for fetching and managing social metrics for a poll with realtime updates
 */
export const usePollSocialMetrics = (pollId?: string) => {
  // Always call the realtime hook with a consistent value
  // Use empty string when pollId is not provided to maintain hook call order
  const hookPollId = pollId || '';
  
  // Always call useSocialMetricsRealtime to maintain hook consistency
  const { metrics, isLoading, updateSocialMetrics, isRealtimeConnected } = useSocialMetricsRealtime(hookPollId, 'poll');
  
  // If no poll ID was provided, return empty metrics but still maintain hook consistency
  if (!pollId) {
    return { 
      metrics: { 
        commentsCount: 0, 
        likesCount: 0, 
        sharesCount: 0,
        isLikedByUser: false,
        isTrending: false,
        heatScore: 0
      }, 
      isLoading: false,
      updateSocialMetrics: () => {},
      isRealtimeConnected: false
    };
  }

  // Return the actual metrics when pollId is provided
  return {
    metrics,
    isLoading,
    updateSocialMetrics,
    isRealtimeConnected
  };
};
